import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { Navigate, Outlet, useLocation, useParams } from 'react-router'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import FormBottomNavBar from '@Components/Navigations/CreateWorkBottomNavs/FormBottomNavBar'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { ICONS } from '@Const/common'
import WizardStepIndicators from '@Components/WizardFlow/WizardStepIndicators'
import { PARAM } from '@App/navigation/param'

const EditWorkLayout = () => {
    const { rightsholderStore, workStore } = useContext(StoresContext)

    const params = useParams<typeof PARAM>()
    const location = useLocation()
    const [currentStep, setCurrentStep] = useState<number>(0)
    const [backLink, setBackLink] = useState<string>()
    const [nextLink, setNextLink] = useState<string>()

    const setLinksToBar = (stepNumber: number) => {
        switch (stepNumber) {
            case 0:
                setBackLink('')
                setNextLink('/edit/submission')
                break
            case 1:
                setBackLink('/edit')
                setNextLink('/edit')
                break
            case 2:
                setBackLink('/edit')
                setNextLink('/edit')
                break
            case 3:
                setBackLink('/edit')
                setNextLink('/edit')
                break
            case 4:
                setBackLink('/edit')
                setNextLink('/edit')
                break
            case 5:
                setBackLink('')
                setNextLink('')
                break
            default:
                break
        }
    }

    const getCurrentStep = (): number => {
        const currentStepUrl = location.pathname.split('/').pop()
        switch (currentStepUrl) {
            case 'edit':
                return 0
            case 'work-details':
                return 1
            case 'writers':
                return 2
            case 'publishers':
                return 3
            case 'recordings':
                return 4
            case 'submission':
                return 5
            default:
                return 0
        }
    }

    useEffect(() => {
        analyticsSendPage('edit_work')
        const stepNumber = getCurrentStep()
        setCurrentStep(stepNumber)
        setLinksToBar(stepNumber)
    }, [location])

    const typeWork = params.typeWork || 'bulk'
    const workID = params.workId
    const currentRightsHolderId = rightsholderStore.currentRightsholderId
    const coreLink =
        typeWork === 'bulk'
            ? `/member/${currentRightsHolderId}/create-work/bulk`
            : `/member/${currentRightsHolderId}/catalog/${typeWork}/${workID}`
    const workDraftFromLocal = workStore.workDraftLocal

    if (!workDraftFromLocal) {
        return <Navigate to={Navigation.rightholder.catalog.root(currentRightsHolderId)} />
    }

    const EditWorkHeader = () => {
        const steps = [
            { stepIndicator: { label: 'Enter Work Details', icon: ICONS.workDetails } },
            { stepIndicator: { label: 'Add Writers', icon: ICONS.writers } },
            { stepIndicator: { label: 'Add Publishers & Shares', icon: ICONS.publishers } },
            { stepIndicator: { label: 'Add Recording', icon: ICONS.recordings } },
            { stepIndicator: { label: 'Review', icon: ICONS.review } },
        ]

        return (
            <div className="head-create-work-wizard">
                <h1>Catalog</h1>
                <WizardStepIndicators currentIndex={currentStep - 1} steps={steps} />
            </div>
        )
    }

    return (
        <div>
            <title>Edit work</title>
            <main className="edit-work-scene">
                <div className="steps-wrapper">
                    {currentStep !== 0 && currentStep !== 5 && <EditWorkHeader />}

                    <Outlet />
                    {!(typeWork === 'bulk' && currentStep === 0) && (
                        <FormBottomNavBar
                            nextLink={`${coreLink}${nextLink}`}
                            backLink={`${coreLink}${backLink}`}
                            typeWork={typeWork}
                            hideBackLink={!!backLink}
                            isFormStep={currentStep === 0}
                            isSubmittedStep={currentStep === 5}
                            isFinishEntityStep={nextLink === '/form'}
                        />
                    )}
                </div>
            </main>
        </div>
    )
}

export default EditWorkLayout
